<template>
   <div class="news-ticker-wrapper" v-if="!isApiCallInProgress && recentPosts.length > 0">
      <div class="news-ticker-container">
         <div class="news-ticker-content">
            <div class="news-ticker-track">
               <span class="news-ticker-item ticker-tagline">
                  <span class="ticker-tagline-text">
                     Enterprise-Grade Nonsense Since 2025
                  </span>
                  <span class="ticker-separator">•</span>
               </span>
               <span v-for="post in recentPosts" :key="'ticker-' + post.id" class="news-ticker-item">
                  <a :href='"/post/" + encodeURIComponent(post.attributes.slug)' class="ticker-link">
                     <strong>{{ post.attributes.category.data.attributes.name }}:</strong> {{ post.attributes.title }}
                  </a>
                  <span class="ticker-separator">•</span>
               </span>
               <span class="news-ticker-item ticker-tagline">
                  <span class="ticker-tagline-text">
                     Enterprise-Grade Nonsense Since 2025
                  </span>
                  <span class="ticker-separator">•</span>
               </span>
               <span v-for="post in recentPosts" :key="'ticker-duplicate-' + post.id" class="news-ticker-item">
                  <a :href='"/post/" + encodeURIComponent(post.attributes.slug)' class="ticker-link">
                     <strong>{{ post.attributes.category.data.attributes.name }}:</strong> {{ post.attributes.title }}
                  </a>
                  <span class="ticker-separator">•</span>
               </span>
            </div>
         </div>
      </div>
   </div>
   <div id="content" class="section bg-transparent my-0 py-0" v-if="isApiCallInProgress">
      <div class="content-wrap pt-5" style="overflow: visible;">
         <div class="container">
            <div class="row border-between">
               <div class="col-lg-7 mb-5 mb-lg-0">
                  <div class="loading-placeholder" style="background-color: #e0e0e0; aspect-ratio: 16/9;"></div>
                  <div class="loading-placeholder" style="height: 2em; width: 60%; background-color: #e0e0e0; margin-top: 1em;"></div>
               </div>
               <div class="col-lg-5">
                  <h3 class="font-body fw-medium mb-4 h4">Recent Posts</h3>
                  <div class="row posts-md col-mb-30">
                     <article class="entry col-12" v-for="i in [1, 2, 3]" :key="i">
                        <div class="grid-inner row gutter-20">
                           <div class="col-md-4">
                              <a class="entry-image">
                                 <div class="loading-placeholder" style="background-color: #e0e0e0; aspect-ratio: 16/9;"></div>
                              </a>
                           </div>
                           <div class="col-md-8">
                              <div class="entry-title title-xs">
                                 <div class="entry-categories">
                                    <div class="loading-placeholder" style="height: 1.2em; width: 80%; background-color: #e0e0e0; margin-bottom: 1em;"></div>
                                 </div>
                                 <h3>
                                    <div class="loading-placeholder" style="height: 2em; width: 100%; background-color: #e0e0e0; margin-bottom: 1em;"></div>
                                 </h3>
                              </div>
                              <div class="entry-meta">
                                 <ul>
                                    <li>
                                       <a href="#">
                                          <div class="loading-placeholder" style="height: 1.2em; width: 60%; background-color: #e0e0e0;"></div>
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                     </article>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="content" class="section bg-transparent my-0 py-0" v-else>
      <div class="content-wrap pt-5" style="overflow: visible;">
         <div class="container">
            <div class="row border-between">
               <div class="col-lg-7 mb-5 mb-lg-0">
                  <article class="entry border-bottom-0 mb-0">
                     <div class="entry-image">
                        <a :href='"/post/" + encodeURIComponent(recentPosts[0]?.attributes.slug)'>
                           <img
                              :src="this.getLargestMediaUrl(recentPosts[0]?.attributes.thumbnail.data)"
                              loading="lazy"
                              :alt="recentPosts[0]?.attributes.thumbnail?.data?.attributes?.alternativeText || recentPosts[0]?.attributes.thumbnail?.data?.attributes?.caption || recentPosts[0]?.attributes.title || 'Article image'"
                              class="image-preview"
                           >
                        </a>
                     </div>
                     <div class="entry-title">
                        <div class="entry-categories">
                           <a :href='"/post/category/" + recentPosts[0]?.attributes.category.data.attributes.name'>
                              {{ recentPosts[0]?.attributes.category.data.attributes.name }}
                           </a>
                        </div>
                        <h3>
                           <a
                              :href='"/post/" + encodeURIComponent(recentPosts[0]?.attributes.slug)'
                              class="stretched-link color-underline"
                           >
                              <span>
                                 {{ recentPosts[0]?.attributes.title }}
                              </span>
                           </a>
                        </h3>
                     </div>
                     <div class="entry-meta">
                        <ul>
                           <li>
                              <a href="#">
                                 {{ convertTimeToDate(recentPosts[0]?.attributes.createdAt) }}
                              </a>
                           </li>
                        </ul>
                     </div>
                     <div class="entry-content">
                        <p>
                           {{ recentPosts[0]?.attributes.description }}
                        </p>
                     </div>
                  </article>
               </div>
               <div class="col-lg-5">
                  <h3 class="font-body fw-medium mb-4 h4">Recent Posts</h3>
                  <div class="row posts-md col-mb-30">
                     <article class="entry col-12" v-for="post in recentPosts.slice(1, 5)" :key="post.id">
                        <div class="grid-inner row gutter-20">
                           <div class="col-md-4">
                              <a
                                 class="entry-image"
                                 :href='"/post/" + encodeURIComponent(post.attributes.slug)'
                              >
                                 <img :src="this.getLargestMediaUrl(post.attributes.thumbnail.data)" :alt="post.attributes.thumbnail?.data?.attributes?.alternativeText || post.attributes.thumbnail?.data?.attributes?.caption || post.attributes.title || 'Article image'">
                              </a>
                           </div>
                           <div class="col-md-8">
                              <div class="entry-title title-xs">
                                 <div class="entry-categories">
                                    <a :href='"/post/category/" + post.attributes.category.data.attributes.name'>
                                       {{ post.attributes.category.data.attributes.name }}
                                    </a>
                                 </div>
                                 <h3>
                                    <a
                                       :href='"/post/" + encodeURIComponent(post.attributes.slug)'
                                       class="stretched-link color-underline"
                                    >
                                       {{ post.attributes.title }}
                                    </a>
                                 </h3>
                              </div>
                              <div class="entry-meta">
                                 <ul>
                                    <li>
                                       <a href="#">
                                          {{ convertTimeToDate(post.attributes.createdAt) }}
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                     </article>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="content" class="section dark my-0 py-0" v-if="isApiCallInProgress">
      <div class="content-wrap pt-5" style="overflow: visible;">
         <div class="container">
            <h2 class="font-body fw-medium">Popular</h2>
            <div class="row border-between">
               <div class="col-lg-7 mb-5 mb-lg-0">
                  <div class="loading-placeholder" style="background-color: #e0e0e0; aspect-ratio: 16/9;"></div>
                  <div class="loading-placeholder" style="height: 2em; width: 60%; background-color: #e0e0e0; margin-top: 1em;"></div>
               </div>
               <div class="col-lg-5">
                  <h3 class="font-body fw-medium mb-4 h4">Highlights</h3>
                  <div class="row posts-md col-mb-30">
                     <article class="entry col-12" v-for="i in [1, 2, 3]" :key="i">
                        <div class="grid-inner row gutter-20">
                           <div class="col-md-4">
                              <a class="entry-image">
                                 <div class="loading-placeholder" style="background-color: #e0e0e0; aspect-ratio: 16/9;"></div>
                              </a>
                           </div>
                           <div class="col-md-8">
                              <div class="entry-title title-xs">
                                 <div class="entry-categories">
                                    <div class="loading-placeholder" style="height: 1.2em; width: 80%; background-color: #e0e0e0; margin-bottom: 1em;"></div>
                                 </div>
                                 <h3>
                                    <div class="loading-placeholder" style="height: 2em; width: 100%; background-color: #e0e0e0; margin-bottom: 1em;"></div>
                                 </h3>
                              </div>
                              <div class="entry-meta">
                                 <ul>
                                    <li>
                                       <a href="#">
                                          <div class="loading-placeholder" style="height: 1.2em; width: 60%; background-color: #e0e0e0;"></div>
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                     </article>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="content" class="section dark my-0 py-0" v-else>
      <div class="content-wrap pt-5" style="overflow: visible;">
         <div class="container">
            <h2 class="font-body fw-medium">Popular</h2>
            <div class="row border-between">
               <div class="col-lg-7 mb-5 mb-lg-0">
                  <article class="entry border-bottom-0 mb-0">
                     <div class="entry-image">
                        <a :href='"/post/" + encodeURIComponent(popularPosts[0]?.attributes.slug)'>
                           <img
                              :src="this.getLargestMediaUrl(popularPosts[0]?.attributes.thumbnail.data)"
                              loading="lazy"
                              :alt="popularPosts[0]?.attributes.thumbnail?.data?.attributes?.alternativeText || popularPosts[0]?.attributes.thumbnail?.data?.attributes?.caption || popularPosts[0]?.attributes.title || 'Article image'"
                              class="image-preview"
                           >
                        </a>
                     </div>
                     <div class="entry-title">
                        <div class="entry-categories">
                           <a :href='"/post/category/" + popularPosts[0]?.attributes.category.data.attributes.name'>
                              {{ popularPosts[0]?.attributes.category.data.attributes.name }}
                           </a>
                        </div>
                        <h3>
                           <a
                              :href='"/post/" + encodeURIComponent(popularPosts[0]?.attributes.slug)'
                              class="stretched-link color-underline"
                           >
                              <span>
                                 {{ popularPosts[0]?.attributes.title }}
                              </span>
                           </a>
                        </h3>
                     </div>
                     <div class="entry-meta">
                        <ul>
                           <li>
                              <a href="#">
                                 {{ convertTimeToDate(popularPosts[0]?.attributes.createdAt) }}
                              </a>
                           </li>
                        </ul>
                     </div>
                     <div class="entry-content">
                        <p>
                           {{ popularPosts[0]?.attributes.description }}
                        </p>
                     </div>
                  </article>
               </div>
               <div class="col-lg-5">
                  <h3 class="font-body fw-medium mb-4 h4">Highlights</h3>
                  <div class="row posts-md col-mb-30">
                     <article class="entry col-12" v-for="post in popularPosts.slice(1, 5)" :key="post.id">
                        <div class="grid-inner row gutter-20">
                           <div class="col-md-4">
                              <a
                                 class="entry-image"
                                 :href='"/post/" + encodeURIComponent(post.attributes.slug)'
                              >
                                 <img :src="this.getLargestMediaUrl(post.attributes.thumbnail.data)" :alt="post.attributes.thumbnail?.data?.attributes?.alternativeText || post.attributes.thumbnail?.data?.attributes?.caption || post.attributes.title || 'Article image'">
                              </a>
                           </div>
                           <div class="col-md-8">
                              <div class="entry-title title-xs">
                                 <div class="entry-categories">
                                    <a :href='"/post/category/" + post.attributes.category.data.attributes.name'>
                                       {{ post.attributes.category.data.attributes.name }}
                                    </a>
                                 </div>
                                 <h3>
                                    <a
                                       :href='"/post/" + encodeURIComponent(post.attributes.slug)'
                                       class="stretched-link color-underline"
                                    >
                                       {{ post.attributes.title }}
                                    </a>
                                 </h3>
                              </div>
                              <div class="entry-meta">
                                 <ul>
                                    <li>
                                       <a href="#">
                                          {{ convertTimeToDate(post.attributes.createdAt) }}
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                     </article>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="content" class="section bg-transparent my-0 py-0">
      <div class="content-wrap pt-5" style="overflow: visible;">
         <div class="container">
            <div class="content-wrap">
               <div class="container mw-lg py-lg-5">
                  <div class="text-center mb-5 mb-lg-6">
                     <h1 class="display-4 mb-4">{{ appConfigs.general.metadata.home }}</h1>
                  </div>
                  <div class="clear"></div>
                  <div class="row grid-border justify-content-center mt-3">
                     <div class="col-lg-4 col-padding py-lg-0">
                        <h3 class="mb-1 fw-semibold">Become an Author</h3>
                        <p class="mb-5">Have something insightful, funny, or thought-provoking to share? Join our community of writers and publish your own articles.</p>
                        <div class="row flex-column gy-1 list-link">
                           <a href="/about#contact" class="fw-medium link-dark h-text-primary"><u>Submit Post</u></a>
                        </div>
                     </div>
                     <div class="col-lg-4 col-padding py-lg-0">
                        <h3 class="mb-1 fw-semibold">Community</h3>
                        <p class="mb-5">Engage with like-minded developers, share experiences, and contribute to discussions about whatever.</p>
                        <div class="row flex-column gy-1 list-link">
                           <a href="/community" class="mb-2 fw-medium link-dark h-text-primary"><u>Join the Community</u></a>
                        </div>
                     </div>
                     <div class="col-lg-4 col-padding py-lg-0">
                        <h3 class="mb-1 fw-semibold">Contact Us</h3>
                        <p class="mb-5">Have questions or feedback? Reach out to us—we’d love to hear from you!</p>
                        <div class="row flex-column gy-1 list-link">
                           <a href="/about#contact" class="mb-2 fw-medium link-dark h-text-primary"><u>Contact Us</u></a>
                           <a href="/about#contact" class="mb-2 fw-medium link-dark h-text-primary"><u>Report Content</u></a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="content" class="section bg-transparent my-0 py-0">
      <div class="content-wrap pt-5">
         <div class="container">
            <div class="container-fluid">
               <div class="row justify-content-center mx-auto mw-md gx-5">
                  <div class="col">
                     <p class="h6 mb-0">
                        This site and its community are designed for entertainment and engagement. While we strive for 
                        accuracy in our content, occasional errors may occur, and community contributions 
                        reflect individual opinions, not the views of the site.  If you have inquiries, wish to rectify misinformation, or 
                        seek clarification about our community, feel free to <a href="/about#contact">Contact Us</a>.
                     </p>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script lang="ts">
import { Post, Media } from '@/models/Cms';
import { getMediaUrls, loadNewContent, loadPopularContent } from '@/utils/cms';
import { convertTimeToDate } from '@/utils/time';
import { Vue, Options } from 'vue-class-component';
import { FrameControl } from '@/models/FrameControl';
import { APP_CONFIGS } from '@/main';
import { setPageMetaTags } from '@/utils/seo';
import { emitPrerenderEvent, detectPrerenderedPage } from '@/utils/seo';
import ArticlePreview from "@/components/post/ArticlePreview.vue";

@Options({
    components: {
        ArticlePreview,
    },
    methods: {
        convertTimeToDate
    }
})
export default class DNDHome extends Vue {

   isApiCallInProgress = false;
   recentPosts: Post[] = [];
   popularPosts: Post[] = [];

   public async mounted(): Promise<void> {
      this.isApiCallInProgress = true;

      // Set SEO meta tags
      setPageMetaTags(
         this.appConfigs.general.metadata.home,
         this.appConfigs.general.metadata.homeDescription || this.appConfigs.general.metadata.about,
         this.appConfigs.assets.logoImage,
         window.location.href,
         {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": this.appConfigs.general.metadata.home,
            "description": this.appConfigs.general.metadata.homeDescription || this.appConfigs.general.metadata.about
         },
         {
            siteName: this.appConfigs.general.name,
            themeColor: this.appConfigs.general.display?.themeColor,
            keywords: this.appConfigs.general.metadata.homeKeywords,
         }
      );

      // Fetch data
      try {
         const [recentPosts, popularPosts] = await Promise.all([
            loadNewContent(5),
            loadPopularContent(5),
         ]);
         this.recentPosts = recentPosts;
         this.popularPosts = popularPosts;
      } catch (err) {
         console.error(err);
      }

      this.isApiCallInProgress = false;

      // Emit prerender event
      emitPrerenderEvent();
   }

   getLargestMediaUrl(media: Media | undefined): string {
      if (!media) return '';
      const urls = getMediaUrls(media);
      return urls.large || urls.original || urls.medium || urls.small || urls.thumbnail || '';
   }

   public convertTimeToDate(dateString: string): string {
      return convertTimeToDate(dateString);
   }

   get appConfigs(): FrameControl {
      return APP_CONFIGS;
   }

   get isPrerendered(): boolean {
      return detectPrerenderedPage();
   }

}
</script>
 
<style scoped>
.dark {
    background-color: #010101 !important;
}
.image-preview {
   width: 100%;
   object-fit: cover;
   object-position: center;
}
.loading-placeholder {
   animation: shimmer 1.5s infinite linear;
   background: #e0e0e0;
   border-radius: 4px;
}

@keyframes shimmer {
   0% {
      background-position: -200px 0;
   }
   100% {
      background-position: 200px 0;
   }
}

.news-ticker-wrapper {
   background: linear-gradient(135deg, #3a3a3a 0%, #2a2a2a 100%);
   border-bottom: 3px solid #58A054;
   overflow: hidden;
   position: relative;
}

.news-ticker-container {
   display: flex;
   align-items: center;
   height: 50px;
   max-width: 100%;
}

.news-ticker-content {
   flex: 1;
   overflow: hidden;
   position: relative;
   height: 100%;
   display: flex;
   align-items: center;
}

.news-ticker-track {
   display: flex;
   align-items: center;
   animation: scroll-ticker 90s linear infinite;
   white-space: nowrap;
}

.news-ticker-track:hover {
   animation-play-state: paused;
}

.news-ticker-item {
   display: inline-flex;
   align-items: center;
   margin-right: 3rem;
}

.ticker-link {
   color: #e0e0e0;
   text-decoration: none;
   transition: all 0.3s ease;
   font-size: 0.95rem;
   font-family: 'Roboto Mono', monospace;
}

.ticker-link:hover {
   color: #58A054;
   text-decoration: none;
}

.ticker-link strong {
   color: #58A054;
   margin-right: 5px;
   font-weight: 600;
}

.ticker-separator {
   color: rgba(255, 255, 255, 0.5);
   margin-left: 3rem;
   font-size: 1.2rem;
}

.ticker-tagline-text {
   color: #58A054;
   font-weight: 700;
   font-size: 1.1rem;
   font-family: 'Roboto Mono', monospace;
   letter-spacing: 1px;
   text-transform: uppercase;
   display: inline-flex;
   align-items: center;
   gap: 8px;
   text-shadow: 0 0 10px rgba(88, 160, 84, 0.3);
}

.ticker-tagline-text i {
   font-size: 1.3rem;
   animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
   0%, 100% {
      transform: scale(1);
   }
   50% {
      transform: scale(1.1);
   }
}

@keyframes scroll-ticker {
   0% {
      transform: translateX(0);
   }
   100% {
      transform: translateX(-50%);
   }
}

@media (max-width: 768px) {
   .ticker-link {
      font-size: 0.85rem;
   }
   
   .news-ticker-container {
      height: 45px;
   }
}
</style>